import * as React from "react";
import type { SVGProps } from "react";
const SvgAlignJustify = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 3.6h19.2M2.4 8.8h19.2M2.4 14h19.2M2.4 19.2h19.2"
    />
  </svg>
);
export default SvgAlignJustify;
